import { render, staticRenderFns } from "./PriceTemplateEdit.vue?vue&type=template&id=6f423dab"
import script from "./PriceTemplateEdit.vue?vue&type=script&lang=ts"
export * from "./PriceTemplateEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports